import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringListFilter',
    standalone: false,
})
export default class StringListFilterPipe implements PipeTransform {
    /**
     *
     * @param strings
     * @param filterValue
     */

    /**
     *
     * @param strings
     * @param filterValue
     */
    transform(strings: string[], filterValue: string): string[] {
        if (!strings) {
            return [];
        }

        if (!filterValue) {
            return strings;
        }

        return strings.filter((item) => item.toLowerCase().indexOf(filterValue.toLowerCase()) > -1);
    }
}
